import { parseSocialIcons } from "@client/lib/settings";
import { createShallowEqualSelector, getLayoutSettingValueSelector } from "@client/selectors";

export const sidePanelSocialSelector = getLayoutSettingValueSelector("social", "sidePanel");
export const sidePanelSocialIconsStyleSelector = getLayoutSettingValueSelector("style", "sidePanel.social");
export const sidePanelSocialIconsSelector = getLayoutSettingValueSelector("icons", "sidePanel.social");
export const itemsSelector = createShallowEqualSelector([sidePanelSocialIconsSelector], (socialIcons) =>
  parseSocialIcons(socialIcons).filter((icon) => !!icon.link)
);
